import { mainApi } from '@main/services'
import { MODE_ENV } from '@domain'
import { utils } from '@/utils/utils'
class RouterHookLogic {
  /**
   * 平铺的路由列表
   */
  flattenRouters = []
  /**
   * 导航菜单配置
   */
  navMenuConfig = []
  /**
   * 记录当前的subSystemCode
   * 因为以前有个对应关系表
   *  {
      "user-center":"customers",
      "control":"BAM",
      "console":'resourceList',
      "application":'applicationService',
      "navigationMenu":"navigationMenu"
    };
   */
  subSystemCode = 'navigationMenu'
  constructor(router, store) {
    /**
     * 全局静态路由配置
     */
    this.router = router
    /**
     * 全局vuex配置
     */
    this.store = store
    /**
     * 缓存所有的静态路由
     */
    this.static_routers = this.router.options.routes
    /**
     * 在store上暴露一个方法，用来判断当前路由是否授权开通
     */
    this.store.$routerHasPermission = this.routerHasPermission.bind(this)
    /**
     * 这个方法是用来监听menuData的变化的
     * 因为像对客端，有客户菜单和BAM菜单的区分，需要实时监听这个菜单的变化
     */
    this.store.$menuDataChanged = this.menuDataChanged.bind(this)
    /**
     * 加载导航菜单
     */
    // this.loadNavMenuData()
    this.store.$loadNavMenuData = this.loadNavMenuData.bind(this)
  }
  /**
   * 处理菜单
   * @param {*} val
   * @returns
   */
  menuDataChanged(val) {
    this.dealMenuData(val)
    return val
  }
  /**
   * 获取导航菜单
   */
  async loadNavMenuData() {
    const userType = utils.getCookie(MODE_ENV + '_user_type_')
    console.log(66, userType)
    if (userType != 1) {
      //渠道
      this.subSystemCode = 'partnerNavMenu'
    }
    // 伙伴渠道 分为两个系统 subSystemCode 在接口处已经写死
    let { obj } = await mainApi.getLeftMenuDataHear(this.subSystemCode)
    console.log(obj)
    if (obj && obj[0]) {
      let levelOne = obj[0]
      if (levelOne && levelOne.children && levelOne.children.length > 0) {
        this.navMenuConfig = levelOne.children
      }
    } else {
      console.error('获取导航菜单失败')
    }
  }
  /**
   * 判断导航是否有权限
   * @param {*} nav
   */
  navHasPermission(nav) {
    return true  //头部导航权限控制 由于子账号 问题 暂时不予以控制
    if (!this.navMenuConfig || this.navMenuConfig.length <= 0) {
      return false
    }
    let res = this.navMenuConfig.find(o => o.path === nav)
    return res !== undefined
  }
  /**
   * 导航栏菜单下拉选项
   * @param {*} navDropdownItem 导航菜单下拉的选项
   */
  navBarItemPermission(navDropdownItem) {
    return true  //头部导航权限控制 由于子账号 问题 暂时不予以控制
    if (!this.navMenuConfig || this.navMenuConfig.length <= 0) {
      return false
    }
    if (!navDropdownItem.includes(':')) {
      return false
    }
    const [parent] = navDropdownItem.split(':')
    let nav = this.navMenuConfig.find(o => o.path === parent)
    if (nav && nav.children && nav.children.length > 0) {
      let childItem = nav.children.find(o => o.perms === navDropdownItem)
      return childItem !== undefined
    }
    return false
  }
  /**
   * 判断当前的路由是否有权限
   * @param {*} currentRouter 当前页面的路由
   */
  routerHasPermission(currentRouter) {
    if (!this.flattenRouters || this.flattenRouters.length <= 0) {
      //还没有加载菜单
      return true
    }
    console.log(`%c ${JSON.stringify(currentRouter.path)}`, 'color:gold;font-size:18px')

    const { path, meta } = currentRouter
    const routerWhiteList = [
      '/', //根路径，一般都是会重定向到指定页面
      '/user-center/account/base-info', //控制台
      '/main/account', //个人中心下面的忘记密码
      '/control/notAllow' //无权限页面
    ]
    if (routerWhiteList.includes(path)) {
      return true
    }
    let res = this.flattenRouters.find(o => o.fullPath === path)
    if (res) {
      //当前的路由是配置了在运营侧
      return true
    } else {
      //当前路由没有配置在运营侧
      //查看父级是否有权限
      const { parent } = meta || {}
      if (!parent) {
        return false
      }
      let res = this.flattenRouters.find(o => o.fullPath === parent)
      return res ? true : false
    }
  }
  /**
   * 对后台返回的菜单数据做一次处理缓存
   * @param {*} dbMenuData
   * @param {*} parentPath
   */
  dealMenuData(dbMenuData, parentPath = '') {
    dbMenuData.forEach(item => {
      item.fullPath = `${parentPath}/${item.path}`
      if (item.children && item.children.length > 0) {
        this.dealMenuData(item.children, item.fullPath)
      }
      this.flattenRouters.push(item)
    })
  }
}

export default {
  install: (Vue, opt) => {
    let routerHooks = new RouterHookLogic(opt.router, opt.store)
    /**
     * 判断当前导航菜单是否有权限
     * @param {*} item 导航菜单项
     * @returns
     */
    Vue.prototype.$navHasPermission = item => {
      return routerHooks.navHasPermission(item)
    }
    /**
     * 个人中心下面按钮
     * @param {*} navDropdownItem
     * @returns
     */
    Vue.prototype.$navBarItemPermission = navDropdownItem => {
      return routerHooks.navBarItemPermission(navDropdownItem)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/routerHookLogic.js